export interface LocationNearbyProps {
  id: string;
  text: string;
  description: string;
  gmaps: string;
  gmaps_link: string;
  location_nearby: {
    id: string;
    title: string;
    description: string;
    icon: string;
  }[];
}

export default function LocationNearby(props: LocationNearbyProps) {
  return (
    <div id="location" className="py-10 xl:py-28 bg-coffebrown">
      <div className="w-full xl:max-w-screen-xl mx-auto px-10 xl:px-0">
        <div className="grid grid-cols-12">
          <div className="col-span-12 xl:col-span-5">
            <h4
              className="text-white text-center xl:text-left xl:text-6xl font-pluto"
              dangerouslySetInnerHTML={{ __html: props.text }}
            ></h4>
            <p
              className="text-white text-center xl:text-left mt-6 text-[13px] xl:text-2xl xl:leading-10"
              dangerouslySetInnerHTML={{ __html: props.description }}
            ></p>
          </div>
          <div className="col-span-12 xl:col-span-7 relative">
            {props.gmaps && <div
              className="[&>iframe]:w-full [&>iframe]:h-[15rem] [&>iframe]:rounded-[9px] [&>iframe]:xl:rounded-none [&>iframe]:xl:h-[32rem] mt-4 xl:mt-0"
              dangerouslySetInnerHTML={{ __html: props.gmaps }}
            ></div>}

            <a href={props.gmaps_link} target="_blank" className="absolute -bottom-3 left-1/2 -translate-x-1/2 block xl:hidden">
              <button className="inline-flex items-center rounded-[4.8rem] bg-gold px-3 xl:px-6 py-1 xl:py-2 cursor-pointer hover:bg-darkgold shadow-[0px_4px_4px_0px_rgba(0,0,0,0.2)]">
                <img
                  src="/map-marker.svg"
                  alt="map-marker"
                  width={46}
                  height={46}
                  loading="lazy"
                  className="w-4 xl:w-8 h-4 xl:h-8"
                />
                <span className="text-white text-[10px] xl:text-3xl ml-2 font-medium">
                  View Google Maps
                </span>
              </button>
            </a>
          </div>
        </div>

        <div className="flex flex-wrap mt-9 xl:mt-24 gap-y-5 xl:gap-y-0 justify-around">
          {props.location_nearby.map((location_nearby) => {
            return (
              <div key={location_nearby.id} className="flex-1/2 xl:flex-none">
                <img
                  src={location_nearby.icon}
                  alt=""
                  className="w-6 xl:w-16 h-6 xl:h-16"
                  loading="lazy"
                  width={64}
                  height={64}
                />
                <p
                  className="text-gold text-[14px] xl:text-3xl mt-1.5 mb-2 xl:mb-4 font-pluto font-medium"
                  dangerouslySetInnerHTML={{ __html: location_nearby.title }}
                ></p>
                <div className="flex flex-col xl:space-y-1">
                  {location_nearby.description.split("\n").map((text, idx) => (
                    <p key={idx} className="text-white text-[10px] xl:text-2xl">
                      {text}
                    </p>
                  ))}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
